// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-vaf-access-finance/calculators-vaf-access-finance.component.scss
// module id = 807
// module chunks = 0